<template>
    <div class="selfExamination">
        <div class="top">
            <img class="selfExamination-img" src="../../../assets/images/degreeApplication/selfExamination.png" alt="" />
            <!-- <img class="noticeOfApplication-img" src="../../../assets/images/degreeApplication/noticeOfApplication.png" alt="" @click="goToClick" /> -->
        </div>
        <div class="cont">
            <h1 class="cont-title">申报条件简述 </h1>
            <div class="cont-item cont-top">
                高等学历继续教育本科毕业生申请授予学士学位，成人高等教育本科毕业生应当在获得本科毕业证书的当年或次年、自考本科毕业生应当在获得本科毕业证书（以毕业证书落款时间为准）1年内提出申请，并符合以下条件：
            </div>
            <div class="cont-item cont-1">
               （一）热爱祖国，拥护中国共产党的领导，拥护社会主义制度，遵纪守法，品行端正，遵守学术道德和学术规范。
            </div>
            <div class="cont-item">
               （二）课程考试（核）成绩要求。
            </div>
            <div class="cont-item cont-3">
                <p>1. 成人高等教育本科毕业生课程平均成绩≥70分（含毕业理论考试成绩、毕业论文成绩）;</p>
                <p>2. 高等教育自学考试本科毕业生课程平均成绩≥70分，临床实习、毕业论文成绩均≥75分（免实习的考生，其“临床实习”成绩视为75分）。高等教育自学考试考生所有课程成绩认定时间均以取得自考本科毕业证书上毕业日期之前的考试成绩为准。</p>
            </div>
            <div class="cont-item">
                （三）外语成绩要求。
            </div>
            <div class="cont-item cont-3">
                <p>成人高等教育学生取得本科学籍后，至申请学位前；自考学生取得本科阶段第一门课程合格成绩后，至获得毕业证书前，满足下列条件之一：</p>
            </div>
            <div class="cont-item cont-3">
                <p>
                    1. 自考学生高等教育自学考试“英语（专升本）”课程，成绩≥70分；
                </p>
                <p>
                    2. 全国大学英语四级及以上考试，成绩≥350分；
                </p>
                <p>
                    3. 全国英语等级考试（PETS）三级及以上，笔试成绩合格；
                </p>
                <p>
                    4. 医学英语水平考试（METS）三级及以上，成绩合格。
                </p>
            </div>
        </div>
    </div>
</template>

<script>
// import { getPatch } from "@/api/degreeApplication";
export default {
    name: 'selfExamination',
    data(){
        return {
            url: '',
        }
    },
    created(){
        // this.getData();
    },
    methods: {
        // 获取学位申请通知链接
        // getData(){
        //     let data = {
        //         tag: 'academicDegreeNotice'
        //     }
        //     getPatch(data).then(res => {
        //         this.url = JSON.parse(res.result.content).link;
        //     });
        // },
        //点击本学期学位申请通知
        // goToClick(){
        //     open(this.url, '_blank');
        // },
    },
}
</script>

<style lang="scss" scoped>
.selfExamination{
    padding: 20px;
    .top{
        display: flex;
        .selfExamination-img,
        .noticeOfApplication-img{
            width: 150px;
            height: 100px;
            object-fit: contain;
        }
        .noticeOfApplication-img{
            cursor: pointer;
        }
    }
    .cont{
        font-weight: 700;
        font-size: 11pt;
        margin-top: 20px;
        .cont-title{
            font-weight: 700;
        }
        .cont-top{
            margin-top: 10px;
        }
        .cont-item{
            font-family: -apple-system, "PingFang SC", "Segoe UI", "Microsoft YaHei", STHeiti, "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji";
            line-height: 30px;
            .color-red{
                color: rgb(255, 0, 0);
                font-family: 方正仿宋_GBK, FZFangSong-Z02S, 方正仿宋, FangSong, STFangsong, fangsong;
                background-color: white;
                font-size: 12pt;
            }
            .color-blue{
                font-family: 方正仿宋_GBK, FZFangSong-Z02S, 方正仿宋, FangSong, STFangsong, fangsong;
                font-size: 12pt;
                color: #006dcc;
            }
            &.cont-1{
                margin-top: 25px;
            }
            &.cont-3{
                padding-left: 40px;   
            }
            a:visited {
                color: #006dcc;
            }
            a:active, a:hover {
                color: #33a0ff;
            }
        }
    }
}
</style>